import React from 'react';
import { connect } from "react-redux";
import PageTable from 'components/PageTable';
const valuesKey=[ "service_name","homelane_scope"] //"moduleDescription"

class OtherServices extends React.Component<any,any> {

  render() {
        const { pageDetails, orderProfileTitle} = this.props;
        const {otherServices} = pageDetails || {};
        const headerList=["Service Name",`${orderProfileTitle} Scope`]//"Module Description"

        return (  
        <div>
        <div className="page-heading">{pageDetails?.name}</div>
        {
            <PageTable tableName={''} headerList={headerList} valuesKey={valuesKey} valuesList={otherServices}></PageTable>
        }  
        </div>
        )
  }
}

// Map Redux state (modified by saga) to component props
const mapStateToProps = (state: any) => ({
  orderProfileTitle: state.wizard.orderProfileTitle
});

export default connect(mapStateToProps)(OtherServices);